import React from "react"
import "./PieChart.css"

const PieChart = ({fractionFilled, fillColor, emptyColor}) => {
  return (
    <div
      className="pie-chart"
      style={{
        backgroundImage: `conic-gradient(${fillColor} 0%, ${fillColor} ${fractionFilled}%, ${emptyColor} ${fractionFilled}%, ${emptyColor} 100%)`
      }}
    />
  )
}

export default PieChart
